<template>
  <div class='classRank'>
    <days @getdays='getDays'></days>
    <div class='skip'>
      <div class='con' v-if="list.skipClassInfo">
       <p class="className"><span>{{curClass.className}}</span>&nbsp;&nbsp;第&nbsp;<span class='color'>{{list.skipClassInfo.sort}}</span>&nbsp;名&nbsp;&nbsp;(累计时长：{{list.skipClassInfo.skipTimes}}分钟)</p>
       <div class='flex-between' v-if="list.skipClassInfo">
            <p>参与人数<br><span class='color'>{{list.skipClassInfo.skipStuNum}}</span><br>总人数：{{list.skipClassInfo.stuNum}}</p>
            <p>累计个数<br><span class='color'>{{list.skipClassInfo.skipNums}}</span><br>人均个数：{{list.skipClassInfo.skipAvgNums}}</p>
       </div>
      </div>
    </div>
     <div class="list ">
        <div class='flex-center top'>
          <p>排名</p>
          <p>班级</p>
          <p>参与人数</p>
          <p>人均个数</p>
        </div>
        <div v-for="(item,i) in list.skipClassList" :key='i' class="flex-center">
            <p :class='"num"+item.ranking'>{{item.ranking}}</p>
            <p>{{item.className}}</p>
            <p>{{item.skipStuNum||'0'}}</p>
            <p>{{item.skipAvgNums||'0'}}</p>
        </div>
      </div>
  </div>
</template>
<script>
import days from '@/components/dateTop.vue';
import {getClassSkipReport} from "@/api/api.report";
  export default {
    data() {
      return {
        date:new Date(),
        list:'',
        schoolId:'',
        curClass:''
      }
    },
    components:{days},
    created(){
     this.curClass=JSON.parse(sessionStorage.classes);
     let date=new Date();
     this.date=this.pubMethod.formatDate(date,'yyyy-MM-dd');
     this.week=date.getDay();
     this.getSkip();
     
    },
    methods: {
       getDays(item){
         this.date=item.date;
         this.getSkip();
       },
       getSkip(){
         this.list=[];
         getClassSkipReport({
              classId:this.curClass.classId,
              reportDate:this.date,
              schoolId:this.loginUser.schoolId
           }).then((data) => {
            if (data && data.result) {
                   this.list=data.result
            }
         })
       },
    },
  }
</script>
<style lang="scss" >
.classRank{
  background: #fff;

  min-height: 100%;
  .skip{
    padding-top: 78px;
    .con{
      text-align: center;
      width: 96%;
      margin:10px auto;
      padding:.2rem 0px;
      background:rgba(255, 146, 102,.1);
      border-radius: 12px;
      font-size: .12rem;
      color:#999;
      .className{
        font-size: .12rem;
        margin-bottom: .2rem;
        text-align: left;
        width:90%;
        margin: 0px auto .12rem;
        span{
          font-size: .14rem;
          color:#7f7f7f;
        }
        .color{
          color:#ff8c68;
          font-size: .18rem;
        }
      }
      .flex-between{
        p{
          line-height:.22rem;
          flex: 1;
        }
        .color{
          color:#333;
          font-size: .18rem;
          font-weight: 560;
        }
      }
    }
  }
  .list{
     line-height: 55px;
     font-size: .15rem;
     color:#7f7f7f;
     
     div{
       p{
         flex: 1;
         text-align: center;
         overflow: hidden;
         white-space: nowrap;
         text-overflow: ellipsis;
         img{
           width:.26rem;
           vertical-align: middle;
         }
         .arrow{
           margin-left: 10px;
         }
       }
     }
     .top{
        margin-bottom: 5px;
        img{
            width:16px;
        }
     }
     .num1{
       background:url(../../assets/img/step/num1.png) no-repeat center top;
       background-size:.26rem auto ;
       width:.26rem;
       line-height: .26rem;
       color:#fff;
     }
     .num2{
       background:url(../../assets/img/step/num2.png) no-repeat center top;
       background-size:.26rem auto ;
       width:.26rem;
       line-height: .26rem;
       color:#fff;
     }
     .num3{
       background:url(../../assets/img/step/num3.png) no-repeat center top;
       background-size:.26rem auto ;
       width:.26rem;
       line-height: .26rem;
       color:#fff;
     }
  }
@media screen and (max-width:400px){
  .list div p{
       &:first-child{
           flex:0 0 50px;
         }
  }
}
}

</style>